import { observable, action } from 'mobx';
import { CompanyAffiliates } from 'api';

class CompanyAffiliatesStore {
  @observable affiliates = [];

  @observable fetchState;

  anketId;

  @action.bound
  async getAffiliates(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await CompanyAffiliates.getAffiliates(anketId);
      this.affiliates = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const companyAffiliatesStore = new CompanyAffiliatesStore();

export default companyAffiliatesStore;
